var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zedplan-player player",attrs:{"data-vjs-player":""}},[_c('video',{ref:"player",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }